import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import Icon from './components/Icon.vue'
import { initApiTypeSession } from './utils/apiType'
import { getForumSession } from './utils/forumSession.js'

initApiTypeSession()
getForumSession().start()

const app = createApp(App)
import i18n from './locales'
app.component("Icon", Icon)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(router)
app.use(i18n)
app.use(ElementPlus)
app.mount('#app')
